//refactor this code to optimize it

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import {
  editApplication,
  getApplication,
  refreshClientToken,
} from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import InputsGroup from "components/Form/InputsGroup";
import SaveChangesButton from "components/Form/SaveChangesButton";
import FormWrapper from "components/Form/FormWrapper";
import Form from "components/Form";
import Input from "components/Form/Input";
import Textarea from "components/Form/Textarea";
import ImageUpload from "components/Form/ImageUpload";
import { cutImageFullPath, getId, handleErrMsg } from "helpers/functions";
import { appEvents, permissions, storeEvents } from "data";
import { Col, Row, Tab, Nav } from "react-bootstrap";
import { ReactComponent as EditIcon } from "assets/svgs/edit.svg";
import { ReactComponent as RefreshIcon } from "assets/svgs/arrow-clockwise.svg";
import ModalWrapperBtn from "components/shared/ModalWrapperBtn";
import FormBuilder from "components/applciations/FormBuilder";
import "styles/applications.css";
import { useForm } from "react-hook-form";

const EditApplication = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading, error, singleApplication } = useSelector(
    (state) => state.applications
  );

  const [editAppInfoCheck, setEditAppInfoCheck] = useState(false);
  const [formObject, setFormObject] = useState({});
  useEffect(() => {
    setFormObject(singleApplication?.appSettings || []);
  }, [singleApplication]);

  let firstFormValues = {
      name: singleApplication?.name || {},
      icon: singleApplication?.icon || "",
      website: singleApplication?.website || "",
      supportEmail: singleApplication?.supportEmail || "",
      description: singleApplication?.description || {},
    },
    secondFormValues = {
      id: getId(singleApplication),
      token: singleApplication?.token || "",
      oauthMode: singleApplication?.oauthMode || "",
      callbackUrl: singleApplication?.callbackUrl || "",
    },
    thirdFormValues = {
      permissions: singleApplication?.permissions || {},
    },
    FourthFormValues = {
      webhookUrl: singleApplication?.webhookUrl,
      webhookSecretKey: singleApplication?.webhookSecretKey,
      webhookSecurityStrategy: singleApplication?.webhookSecurityStrategy,
      events: singleApplication?.events || [
        "productsCreate",
        "productsDataUpdate",
      ],
      customHeaders: singleApplication?.customHeaders || [
        { special: "asd", value: "asd" },
      ],
    },
    fifthFormValues = {
      trustedIps: singleApplication?.trustedIps || ["192.168.1.1"],
    },
    sixthFormValues = {
      appSettings: singleApplication?.appSettingsForm || {},
      appSettingsValidationUrl:
        singleApplication?.appSettingsValidationUrl || "",
    },
    seventhFormValues = {
      appSnippets: singleApplication?.appSnippets || [],
    };

  const {
    handleSubmit: handleSubmitCredentials,
    getValues: getValuesCredentials,
    register: registerCredentials,
    watch: watchCredentials,
    formState: { errors: errorsCredentials },
    reset: resetCredentials,
  } = useForm();

  // effects
  useEffect(() => {
    resetCredentials({
      ...secondFormValues,
    });
  }, [resetCredentials, singleApplication]);
  useEffect(() => {
    dispatch(getApplication(id));
  }, [dispatch, id]);

  // error
  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  const onSubmitDetails = (data) => {
    data.icon = cutImageFullPath(data?.icon);
    dispatch(
      editApplication({ endpointName: "applicationInfoUpdate", id, data })
    );
    setEditAppInfoCheck(!editAppInfoCheck);
  };
  const onSubmitCredentials = (data) => {
    dispatch(
      editApplication({ endpointName: "applicationKeysUpdate", id, data })
    );
  };
  const onSubmitWebhook = (data) => {
    dispatch(
      editApplication({ endpointName: "applicationWebhooksUpdate", id, data })
    );
  };
  const onSubmitIps = (data) => {
    dispatch(
      editApplication({
        endpointName: "applicationTrustedIpsUpdate",
        id,
        data,
      })
    );
  };
  const onSubmitPermissions = (data) => {
    dispatch(
      editApplication({
        endpointName: "applicationPermissionsUpdate",
        id,
        data,
      })
    );
  };
  const onSubmitSettings = (data) => {
    data.appSettings = formObject;

    dispatch(
      editApplication({ endpointName: "applicationSettingsUpdate", id, data })
    );
  };
  const onSubmitSnippets = (data) => {
    dispatch(
      editApplication({ endpointName: "applicationSnippets", id, data })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="applications">
      <FormWrapper title={"editApplication"} lg={12}>
        <Col lg={12}>
          <Form onSubmit={onSubmitDetails} defaultValues={firstFormValues}>
            <div className="form-group branches features">
              <Row>
                <Col xs="3">
                  <div className="d-flex justify-content-center align-items-center h-100 separated">
                    <ImageUpload
                      name="icon"
                      langId={false}
                      classNames="m-auto"
                      rules={{}}
                    />
                  </div>
                </Col>
                {!editAppInfoCheck ? (
                  <Col>
                    <Row>
                      <Col xs="12">
                        <label>
                          {singleApplication?.name?.[locale] || "name"}
                          <span
                            className="cursor-pointer"
                            onClick={() =>
                              setEditAppInfoCheck(!editAppInfoCheck)
                            }
                          >
                            <EditIcon
                              width="32"
                              height="32"
                              fill="#fff"
                              className="bg-info rounded-circle p-2"
                            />
                          </span>
                        </label>
                      </Col>
                      <Col xs="12">
                        <div className="d-flex algin-items-center flex-wrap gap-2">
                          <label className="d-flex algin-items-center separated">
                            <FormattedMessage id="appNumber" /> :{" "}
                            <span className="text-muted">
                              {singleApplication?.number || "2132"}
                            </span>
                          </label>

                          <div className="w-auto algin-items-center separated">
                            <a href={`${singleApplication?.website}`}>
                              <FormattedMessage id="appLink" />
                            </a>
                          </div>
                          <div className="w-auto algin-items-center separated">
                            <a
                              href={`mailto:${singleApplication?.supportEmail}`}
                            >
                              <FormattedMessage id="supportMail" />
                            </a>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col xs="12">
                        <h5>{singleApplication?.description?.[locale]}</h5>
                      </Col>
                    </Row>
                    <br />

                    <div className="d-flex flex-wrap gap-2">
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="status" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.status || "notActive"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="type" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.type || "notActive"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="subscriptions" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.activeAppSubscriptionCount ||
                              "0"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="testSubscriptions" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.testSubscriptions || "0"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="endedSubscriptions" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.inactiveAppSubscriptionCount ||
                              "0"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <FormattedMessage id="endedTestSubscriptions" /> :{" "}
                          <span className="text-muted">
                            {singleApplication?.endedTestSubscriptions || "0"}
                          </span>
                        </label>
                      </div>
                      <div className="w-auto algin-items-center separated">
                        <label>
                          <Link to="revisions/" className="cursor-pointer">
                            <FormattedMessage id="revisions" /> :{" "}
                            <span className="text-muted">
                              {singleApplication?.reviewsCount || "0"}
                            </span>
                          </Link>
                        </label>
                      </div>
                    </div>
                  </Col>
                ) : (
                  <>
                    <Row>
                      <Input name="name" locale="ar" langId="name" />
                      <Input name="name" locale="en" langId="name" />

                      <Textarea
                        name="description"
                        locale="ar"
                        langId="description"
                      />
                      <Textarea
                        name="description"
                        locale="en"
                        langId="description"
                      />

                      <Input name="website" langId="appLink" />
                      <Input name="supportEmail" langId="supportEmail" />
                    </Row>

                    <SaveChangesButton className="mt-2 justify-content-end" />
                  </>
                )}
              </Row>
            </div>
          </Form>
        </Col>

        <Col lg={12}>
          <form onSubmit={handleSubmitCredentials(onSubmitCredentials)}>
            <div className="form-group branches features row">
              <Row>
                <Col xs="12" md="4">
                  <h5>
                    <FormattedMessage id="appKeys" />
                  </h5>
                </Col>
                <Col xs="12" md="8">
                  <Col xs="12">
                    <Input
                      register={registerCredentials}
                      getValues={getValuesCredentials}
                      name="id"
                      copyable="true"
                      readOnly={true}
                      lg="12"
                    />
                  </Col>
                  <Col xs="12">
                    {/* <div className="form-control form-outline"> */}
                    <Input
                      register={registerCredentials}
                      errors={errorsCredentials}
                      name="token"
                      type="password"
                      readOnly={true}
                      toggleview="true"
                      lg="12"
                      style={{ direction: "ltr" }}
                      extrabtnicon={<RefreshIcon />}
                      extrabtnfunc={() => dispatch(refreshClientToken(id))}
                    />
                    {/* </div> */}
                  </Col>
                  <Col xs="12">
                    <Input
                      register={registerCredentials}
                      errors={errorsCredentials}
                      name="oauthMode"
                      type="radio"
                      value="easyMode"
                      langId="easyMode"
                    />
                    <Input
                      register={registerCredentials}
                      errors={errorsCredentials}
                      name="oauthMode"
                      type="radio"
                      value="customMode"
                      langId="customMode"
                    />
                    {watchCredentials("oauthMode") == "customMode" && (
                      <Input
                        register={registerCredentials}
                        errors={errorsCredentials}
                        name="callbackUrl"
                        type="url"
                      />
                    )}
                  </Col>
                </Col>
              </Row>
              <SaveChangesButton className="mt-2 justify-content-end" />
            </div>
          </form>
        </Col>

        <Col lg={12}>
          <Form onSubmit={onSubmitPermissions} defaultValues={thirdFormValues}>
            <div className="form-group branches features">
              <Row>
                <Col xs="12" md="4">
                  <h5>
                    <FormattedMessage id="appPermissions" />
                  </h5>
                </Col>
                <Col xs="12" md="8">
                  <Row>
                    {permissions?.map((e, index) => (
                      <Col xl="3" md="4" xs="6" className="mt-2" key={index}>
                        <div className="add-multi-component bg-transparent">
                          <h5>
                            <FormattedMessage id={e} />
                          </h5>
                          <label className="row">
                            <input
                              type="hidden"
                              name={`permissions.${index}.id`}
                              value={e}
                            />
                            <Input
                              type="checkbox"
                              name={`permissions.${index}.canRead`}
                              langId={false}
                              rules={{ required: false }}
                              value={true}
                              xs="4"
                            />
                            <Col as="small">
                              <FormattedMessage id="canRead" />
                            </Col>
                          </label>
                          <label className="row">
                            <Input
                              type="checkbox"
                              name={`permissions.${index}.canWrite`}
                              langId={false}
                              rules={{ required: false }}
                              value={true}
                              xs="4"
                            />
                            <Col as="small">
                              <FormattedMessage id="canWrite" />
                            </Col>
                          </label>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
              <SaveChangesButton className="mt-2 justify-content-end" />
            </div>
          </Form>
        </Col>

        <Col lg={12}>
          <Form onSubmit={onSubmitWebhook} defaultValues={FourthFormValues}>
            <div className="form-group branches features">
              <Row>
                <Col xs="12" md="4">
                  <h5>
                    <FormattedMessage id="alerts" />
                  </h5>
                </Col>
                <Col xs="12" md="8" className="row">
                  <Col xs="12">
                    <Input
                      name="webhookUrl"
                      type="url"
                      lg="12"
                      rules={{ required: false }}
                      autoCapitalize="off"
                      autoComplete="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </Col>
                  <Col xs="12">
                    <label>
                      <FormattedMessage id="webhookSecurityStrategy" />
                    </label>
                    <Row>
                      <Input
                        name="webhookSecurityStrategy"
                        type="radio"
                        value="signature"
                        langId={false}
                        xs="4"
                        lg="2"
                        breakpoints={{ md: 3 }}
                        rules={{ required: false }}
                      >
                        <small className="ps-2">
                          <FormattedMessage id="signature" />
                        </small>
                      </Input>
                      <Input
                        name="webhookSecurityStrategy"
                        type="radio"
                        value="token"
                        langId={false}
                        xs="4"
                        lg="2"
                        breakpoints={{ md: 3 }}
                        rules={{ required: false }}
                      >
                        <small className="ps-2">
                          <FormattedMessage id="token" />
                        </small>
                      </Input>
                      <Input
                        name="webhookSecurityStrategy"
                        type="radio"
                        value="none"
                        langId={false}
                        xs="4"
                        lg="2"
                        breakpoints={{ md: 3 }}
                        rules={{ required: false }}
                      >
                        <small className="ps-2">
                          <FormattedMessage id="none" />
                        </small>
                      </Input>
                    </Row>
                  </Col>
                  <Col xs="12">
                    <Input
                      name="webhookSecretKey"
                      type="password"
                      toggleview="true"
                      lg="12"
                      rules={{ required: false }}
                      autoCapitalize="off"
                      autoComplete="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                  </Col>
                </Col>
                <Col xs="12">
                  <div className="d-flex justify-content-between">
                    <label>
                      <FormattedMessage id="applicationEvents" />
                    </label>
                    <Col xs="4" lg="2" md="3">
                      <ModalWrapperBtn
                        title={<FormattedMessage id="applicationEvents" />}
                        btnText={<FormattedMessage id="showEvents" />}
                        btnClassName="bg-transparent border border-info text-info"
                        handleSave={() => {}}
                      >
                        <div>
                          {appEvents?.map((e, index) => (
                            <Row key={index}>
                              <a href={e?.website}>{e.label}</a>
                            </Row>
                          ))}
                        </div>
                      </ModalWrapperBtn>
                    </Col>
                  </div>
                </Col>
                <Col xs="12">
                  <div className="d-flex justify-content-between">
                    <label>
                      <FormattedMessage id="storeEvents" />
                    </label>
                    <Col xs="4" lg="2" md="3">
                      <ModalWrapperBtn
                        title={<FormattedMessage id="storeEvents" />}
                        btnText={<FormattedMessage id="addEvents" />}
                        btnClassName="bg-transparent border border-info text-info"
                        handleSave={() => {}}
                      >
                        <Tab.Container
                          id="left-tabs-example"
                          defaultActiveKey={storeEvents?.[0]?.name}
                        >
                          <Row>
                            <Col xs="4">
                              <Nav variant="pills" className="flex-column">
                                {storeEvents?.map((e, k) => (
                                  <Nav.Item key={k}>
                                    <Nav.Link eventKey={e?.name}>
                                      <FormattedMessage id={e?.name} />
                                    </Nav.Link>
                                  </Nav.Item>
                                ))}
                              </Nav>
                            </Col>
                            <Col xs="8">
                              <Tab.Content>
                                {storeEvents?.map((e, k) =>
                                  e?.options?.map((op, k1) => (
                                    <Tab.Pane
                                      eventKey={e?.name}
                                      key={`${k}-${k1}`}
                                    >
                                      <Input
                                        type="checkbox"
                                        name="events[]"
                                        value={op}
                                        langId={false}
                                        lg="12"
                                      >
                                        <small className="ps-2">{op}</small>
                                      </Input>
                                    </Tab.Pane>
                                  ))
                                )}
                              </Tab.Content>
                            </Col>
                          </Row>
                        </Tab.Container>
                      </ModalWrapperBtn>
                    </Col>
                  </div>
                </Col>
                <Col xs="12">
                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <Col xs="12" md="4">
                      <label>
                        <FormattedMessage id="customHeaders" />
                      </label>
                    </Col>
                    <Col xs="12" md="6">
                      <InputsGroup
                        title={false}
                        name="customHeaders"
                        inputs={[
                          {
                            name: "special",
                            type: "text",
                          },
                          {
                            name: "value",
                            type: "text",
                          },
                        ]}
                      />
                    </Col>
                  </div>
                </Col>
              </Row>
              <SaveChangesButton className="mt-2 justify-content-end" />
            </div>
          </Form>
        </Col>
        <Col xs="12">
          <Form onSubmit={onSubmitIps} defaultValues={fifthFormValues}>
            <div className="form-group branches features">
              <InputsGroup
                name="trustedIps"
                inputs={[
                  {
                    name: "",
                    type: "text",
                  },
                ]}
              />
              <SaveChangesButton className="mt-2 justify-content-end" />
            </div>
          </Form>
        </Col>
        <Col xs="12">
          <Form
            onSubmit={onSubmitSettings}
            defaultValues={sixthFormValues}
            className="app-settings"
          >
            <div className="form-group branches features">
              <div className="d-flex justify-content-between">
                <h5>
                  <FormattedMessage id="appSettings" />
                </h5>
                <Col xs="4" lg="2" md="3">
                  <ModalWrapperBtn
                    fullscreen
                    size="xl"
                    title={<FormattedMessage id="appSettings" />}
                    btnText={
                      <FormattedMessage
                        id="builder"
                        values={{
                          str: <FormattedMessage id="appSettings" />,
                        }}
                      />
                    }
                    btnClassName="bg-transparent border border-info text-info"
                    handleSave={() => console.log(formObject)}
                    modalClass="application-settings-modal"
                    closeBtn={false}
                  >
                    <FormBuilder
                      formObject={formObject}
                      setFormObject={setFormObject}
                    />
                  </ModalWrapperBtn>
                </Col>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <span>
                  <FormattedMessage id="appSettingsValidationUrl" />
                </span>
                <Col xs="7">
                  <Input
                    type="url"
                    name="appSettingsValidationUrl"
                    langId={false}
                    lg="12"
                  />
                </Col>
              </div>
              <SaveChangesButton className="mt-2 justify-content-end " />
            </div>
          </Form>
        </Col>

        <Col xs="12">
          <Form onSubmit={onSubmitSnippets} defaultValues={seventhFormValues}>
            <div className="form-group branches features">
              <InputsGroup
                name="appSnippets"
                inputs={[
                  {
                    name: "name",
                    type: "text",
                  },
                  {
                    name: "position",
                    type: "select",
                    id: "1",
                    placholder: "choose position",
                    hasLocales: false,
                    options: [
                      { value: "body", label: "<body>" },
                      { value: "head", label: "<head>" },
                    ],
                    rules: { required: false },
                  },
                  {
                    name: "snippet",
                    type: "code",
                  },
                ]}
              />
              <SaveChangesButton className="mt-2 justify-content-end" />
            </div>
          </Form>
        </Col>
        <Col xs="12">
          <div className="form-group branches features row">
            <div className="d-flex justify-content-between">
              <h5 className="mb-0">
                <FormattedMessage id="customPlans" />
              </h5>
              <Link
                to={`/applications/${id}/custom-plans`}
                className="border border-info text-info p-2 rounded-2"
              >
                <FormattedMessage id="customPlans" />
              </Link>
            </div>
          </div>
        </Col>

        <Col xs="12">
          <div className="form-group pt-3">
            <Col xs="12">
              <ModalWrapperBtn
                title={<FormattedMessage id="publishRequest" />}
                btnText={<FormattedMessage id="publishRequest" />}
                btnClassName="bg-transparent border border-info text-info"
                handleSave={() => navigate("/identityVerification")}
              >
                <div className="form-group">
                  <label className="text-warning text-center w-100">
                    <FormattedMessage id="confirmAppPublishRequest" />
                  </label>
                </div>
              </ModalWrapperBtn>
            </Col>
          </div>
        </Col>
      </FormWrapper>
    </div>
  );
};

export default EditApplication;
